import Pageable from 'model/page/Pageable';
import { createContext, useContext, useState } from 'react';

interface FilterContextType {
    filters: { [key: string]: any }; 
    pageables: { [key: string]: Pageable };
    updateFilters: (screen: string, newFilters: any) => void;
    updatePageable: (screen: string, newPageable: Pageable) => void;
}

const FilterContext = createContext<FilterContextType>({filters:{}, pageables: {}, updateFilters: () => {}, updatePageable: () => {}});

export function FilterProvider({ children }: { children: React.ReactNode }) {
    const [filters, setFilters] = useState({});
    const [pageables, setPageables] = useState({});

    const updateFilters = (screen: string, newFilters : any) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            [screen]: newFilters,
        }));
    };

    const updatePageable = (screen: string, newPageable : Pageable) => {
        setPageables((prevPageables) => ({
            ...prevPageables,
            [screen]: newPageable,
        }));
    }

    return (
        <FilterContext.Provider value={{ filters, pageables, updateFilters, updatePageable }}>
            {children}
        </FilterContext.Provider>
    );
}

// Custom hook para usar o contexto
export function useFilter() {
    return useContext(FilterContext);
}
